<template>
  <div class="training_table">
    <main>
      <div class="main_view">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="操作项目：" prop="name">
            <p></p>
          </el-form-item>
          <el-form-item label="考核完成时间：" prop="time">
            <p></p>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <div class="oper_box" v-if="propertyType == 1 || Level == 1">
          <el-button @click="addClick(0)">
            <img src="@/assets/button_imgs/tianjia.png" alt="" />
            添加项目
          </el-button>
          <el-button @click="addClick(1)">
            <img src="@/assets/button_imgs/tianjia.png" alt="" />
            添加负分项
          </el-button>
        </div>
        <el-table
          v-if="
            (propertyType == 1 && $route.query.type == 0) ||
            ($route.query.type == 1 && Level == 1)
          "
          :data="tableData"
          stripe
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
          :header-cell-style="{
            'background-color': '#EEEEEE',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="项目" width="180">
            <template slot-scope="scope">
              <el-input
                type="textarea"
                class="one_text"
                @input="clearRed(scope.row)"
                :class="scope.row.stateNull == 1 ? 'redtes' : ''"
                v-model.trim="scope.row.name"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="项目分" prop="projectScore">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <el-input
                  v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
                  v-model.trim="scope.row.projectScore"
                  :class="scope.row.scoreNull == 1 ? 'redtext' : ''"
                  maxlength="3"
                  @input="
                    checkScore(scope.row.projectScore, scope.row, scope.$index)
                  "
                ></el-input>
                <p
                   v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                  style="color: red; text-align: left"
                >
                  扣分项不需要指定分数，根据实际规定扣分即可
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分"> </el-table-column>
          <el-table-column prop="address2" label="扣分细节" width="300">
          </el-table-column>
          <el-table-column prop="operation" label="">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="scope.$index == 0"
                @click="moveUp(scope.$index)"
                >上移</el-button
              >
              <el-button
                type="text"
                @click="moveDown(scope.$index)"
                :disabled="scope.$index == tableData.length - 1"
                >下移</el-button
              >
              <el-button
                type="text"
                @click="deleteClick(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Second
          ref="second"
          v-else-if="
            (propertyType == 2 && $route.query.type == 0) ||
            ($route.query.type == 1 && Level == 2)
          "
        />
        <Tertiary
          ref="tertiary"
          v-else-if="
            (propertyType == 3 && $route.query.type == 0) ||
            ($route.query.type == 1 && Level == 3)
          "
        />
        <div class="passScore">
          <p>及格分：</p>
          <el-input v-model.trim="passScore"></el-input>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import assessApi from "@/api/assessment";
import Second from "./Second.vue";
import Tertiary from "./Tertiary.vue";
import { objecAtrtIsEmpty } from "@/state/operation";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      ruleForm: {
        name: "", // 操作项目名称
        time: "", // 结束时间
      },
      passScore: "", // 及格分
      total: "", // 合计
      tableData: [
        {
          buckleType: 1, // 是否扣分项 1否 2是
          name: "", // 项目名称
          projectScore: 10, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          scoreNull: "0", // 项目分是否为空
        },
      ],
      title: "", // 标题
      titleType: true, // 默认不编辑
      sundflag: false, // 防抖
      timer: null, // 保存定时器
      propertyType: "", // 表格性质
      Level: "", // 编辑回显数据
      rules: {
        // name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        // time: [
        //   {
        //     required: true,
        //     message: "请选择日期",
        //     trigger: "change",
        //   },
        // ],
      },
    };
  },
  components: {
    Second,
    Tertiary,
  },
  props: ["parameter"],
  methods: {
    // 编辑
    editorTitle() {
      this.titleType = !this.titleType;
      // this.title = "护理人员技术考核表";
    },
    // 编辑当前行
    editorClick(row) {
      row.type = !row.type;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setSaveData();
        } else {
          this.$message({
            message: "警告，当前还有信息未填写！",
            type: "warning",
          });
          return false;
        }
      });
    },
    // 添加
    addClick(type) {
      let obj = {};
      if (type == 0) {
        // 添加
        obj = {
          buckleType: 1, // 是否扣分项
          name: "", // 项目名字
          projectScore: "", // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          scoreNull: "0", // 项目分是否为空
        };
      } else if (type == 1) {
        // 添加负分项
        obj = {
          buckleType: 2, // 是否扣分项
          name: "扣分", // 项目名字
          projectScore: -1, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          scoreNull: "0", // 项目分是否为空
        };
      }
      this.tableData.push(obj);
    },
    // 上移
    moveUp(index) {
      let arr = this.tableData;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
    },
    // 下移
    moveDown(index) {
      let arr = this.tableData;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
    },

    // 删除
    deleteClick(row, index) {
      this.tableData.splice(index, 1);
    },
    // 清除不为空的红框
    clearRed(row, type) {
      if (row.name == "") {
        return;
      } else if (row.name !== "" && row.stateNull) {
        row.stateNull = "0";
      }
    },
    // 过滤出为空显示红框
    filtrationRed() {
      if (
        this.propertyType == 1 ||
        (this.Level == 1 && this.$route.query.type == 1)
      ) {
        // 一级   编辑如果没生效，可能遗留数据没有添加状态
        this.tableData.forEach((item) => {
          if (item.name == "") {
            item.stateNull = "1";
          }
          if (item.projectScore == "") {
            item.scoreNull = "1";
          }
        });
      } else if (
        this.propertyType == 2 ||
        (this.Level == 2 && this.$route.query.type == 1)
      ) {
        // 二级
        this.$refs.second.tableData.forEach((item) => {
          if (item.name == "") {
            item.stateNull = "1";
          }
          item.child.forEach((zitem) => {
            if (zitem.content == "") {
              zitem.contentNull = "1";
            }
            if (zitem.scoreValue == "") {
              zitem.scoreNull = "1";
            }
          });
        });
      } else if (
        this.propertyType == 3 ||
        (this.Level == 3 && this.$route.query.type == 1)
      ) {
        // 三级
        this.$refs.tertiary.tableData.forEach((item) => {
          if (item.name == "") {
            item.stateNull = "1";
          }
          item.child.forEach((zitem) => {
            if (zitem.secondName == "") {
              zitem.twoStateNull = "1";
            }
            zitem.child.forEach((sitem) => {
              if (sitem.content == "") {
                sitem.contentNull = "1";
              }
              if (sitem.scoreValue == "") {
                sitem.scoreNull = "1";
              }
            });
          });
        });
      }
    },
    // 保存
    async setSaveData() {
      if (
        this.propertyType == 2 ||
        (this.Level == 2 && this.$route.query.type == 1)
      ) {
        this.tableData = this.$refs.second.tableData; // 表格数据
        this.total = this.$refs.second.total; // 合计
      } else if (
        this.propertyType == 3 ||
        (this.Level == 3 && this.$route.query.type == 1)
      ) {
        this.tableData = this.$refs.tertiary.tableData;
        this.total = this.$refs.tertiary.total;
      }
      if (this.tableData.length == 0) {
        this.$message({
          message: "警告，当前表格为空，请添加！",
          type: "warning",
        });
        return;
      }
      // 这里如果提交失败后需再次将0变成-1
      this.tableData.forEach((item) => {
        if (item.buckleType && item.buckleType == 2) {
          item.projectScore = -1;
        }
      });
      let type = objecAtrtIsEmpty(this.tableData); // 判断是否有空值  0 也算空
      // console.log(this.passScore, this.total);
      if (type == false) {
        this.$message({
          message: "警告，当前还有未填写项，请填写后再进行保存",
          type: "warning",
        });
        //
        this.filtrationRed(); // 过滤显示没填写的展示红框
        console.log(this.tableData);
      } else if (Number(this.passScore) > this.total || this.passScore == "") {
        this.$message({
          message: "警告，请添加及格分,当前及格分不能大于合计项目分",
          type: "warning",
        });
      } else {
        let arr = this.tableData.map((item) => {
          if (item.buckleType && item.buckleType == 2) {
            // 有扣分项
            item.projectScore = 0; // 这里重置归0，绕过0为空的校验
          }
          this.$set(item, "passScore", this.passScore); // 及格分
          return item;
        });
        let obj = {
          title: this.title, // 名称
          level:
            this.propertyType == undefined ? this.Level : this.propertyType, // 层级
          contentTxt: JSON.stringify(arr), // 内容列表数组
          passScore: this.passScore, // 及格分
          totalScore: this.total, // 总分
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.userlist).hid,
        };
        if (this.$route.query.type == 0) {
          // 新增
          this.sundflag = true;
          const { data } = await assessApi.addScore(obj);
          if (data.Status == 200) {
            this.$message({
              message: "恭喜你，新增成功",
              type: "success",
            });
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
            this.$parent.back();
          } else {
            this.sundflag = false;
            this.$message.error(data.Msg);
          }
        } else if (this.$route.query.type == 1) {
          // 编辑
          obj.scoreID = this.$route.query.ID;
          this.sundflag = true;
          const { data } = await assessApi.editScore(obj);
          if (data.Status == 200) {
            this.$message({
              message: "恭喜你，编辑修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
            this.$parent.back();
          } else {
            this.sundflag = false;
            this.$message.error(data.Msg);
          }
        }
      }
    },
    // 判断当前是否数字
    checkScore(row, obj, index) {
      console.log(row);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (isNaN(row) == true) {
          this.$message({
            message: "警告，分数必须是数字",
            type: "warning",
          });
          this.tableData[index].projectScore = ""; // 清除当前输入框分数
        }
      }, 500);
      if (row == "") {
        return;
      } else if (row !== "") {
        obj.scoreNull = "0";
      }
    },
    //合计
    getSummaries(param) {
      let { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        data = data.filter((item) => {
          // return item.buckleType == 1; // 扣分项不参与合计计算
          if (!item.buckleType || item.buckleType == 1) {
            return item;
          }
        });
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "projectScore") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      this.total = sums[2];
      return sums;
    },
    // 编辑回显
    async editTheEcho() {
      if (this.$route.query.type == 1) {
        let row = this.$storage.sessionGet("rowObj", true);
        this.Level = this.$storage.sessionGet("rowObj", true).Level;
        // console.log(this.Level, this.$route.query.type);
        this.title = row.Title;
        this.tableData = JSON.parse(row.ContentTxt).map((item) => {
          if (item.buckleType && item.buckleType == 2) {
            item.projectScore = -1;
          }
          return item;
        });
      // 有上传表格无scoreValue字段
        this.tableData.forEach(item=>{
          if(item.child){
            item.child.forEach(zitem=>{
              if(!zitem.scoreValue){
                zitem.scoreValue = 0// 给个默认值
              }
            })
          }
        })
        // this.tableData = JSON.parse(row.ContentTxt);
        // console.log(this.tableData);
        this.passScore = row.PassScore;
      }
    },
  },
  activated() {
    // this.passScore = "";
    this.propertyType = this.parameter.property;
    this.title = this.parameter.ratingName;
    this.editTheEcho();
  },
  created() {
    // this.tableData.map((item) => {
    //   this.$set(item, "name", "准备"); // 项目名称
    //   this.$set(item, "points", 50); // 项目分
    //   this.$set(item, "type", true); // 是否编辑状态
    //   this.$set(item, "score", ""); // 得分
    //   this.$set(item, "scoreTxte", ""); // 扣分细节
    // });
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
}
.padding {
  padding: 30px 36px 0px 36px;
  // margin-bottom: 30px;
}
main {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  .main_view {
    min-width: 966px;
    min-height: 540px;
    .title_view {
      p {
        text-align: center;
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #333333;
        line-height: 78px;
      }
    }

    ::v-deep .el-form {
      display: flex;
      margin-top: 20px;
    }
  }
  .el-form-item {
    // width: 200px;
    flex: 1;
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-form-item:nth-child(1) {
    margin-right: 36px;
    .el-form-item__label {
      width: 100px !important;
    }
    .el-form-item__content {
      margin-left: 100px !important;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.red {
  border: 1px solid red;
  border-radius: 4px;
  &:focus {
    border-color: red !important;
  }
}
.redtes {
  ::v-deep .el-textarea__inner {
    border-color: red !important;
  }
}
.redtext {
  ::v-deep .el-input__inner {
    border-color: red !important;
  }
}
.title_view {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
  .el-input {
    width: 270px;
  }
  img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    &:nth-child(1) {
      width: 140px;
    }
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
.img_ {
  display: inline-block;
  font-size: 22px;
  width: 18px;
  height: 18px;
}
.button_ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 38px;
  margin-bottom: 40px;
}
i {
  margin-left: 10px;
  color: red;
}

.passScore {
  margin-top: 24px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    width: 100px;
  }
  ::v-deep .el-input__inner {
    width: 100px;
  }
}
.one_text {
  ::v-deep .el-textarea__inner {
    resize: none;
    width: 160px;
    height: 40px !important;
  }
}
// ::v-deep .el-textarea__inner {
//   resize: none;
//   width: 160px;
//   height: 60px !important;
//   // margin: 6px 10px;
// }
</style>
